import { injectGlobal } from 'emotion';
import 'codemirror/lib/codemirror.css';
// tslint:disable
injectGlobal `
  .icon-link {
    display: none;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .with-overlay {
    overflow: hidden;
  }

  html, body, #root {
    height: 100%;
    min-height: 100%;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2xvYmFsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3N0eWxlcy9nbG9iYWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLFNBQVMsQ0FBQTtBQUN0QyxPQUFPLCtCQUErQixDQUFBO0FBRXRDLGlCQUFpQjtBQUNqQixZQUFZLENBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQWtCWCxDQUFBIn0=